export default () => ({
  type: null,
  licencePlate: null,
  email: '',
  duration: 1,
});
